module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Regular.872bdb62.ttf";